import React, { useEffect, useState } from 'react';
import BZModal from 'BZModal';
import BootstrapData from 'models/BootstrapData';
import { renderReact } from 'utils/reactRoot';
import { CloseIcon } from '@bizzabo/icons';
import Cookies from 'js-cookie';
import { verifyToken, decodeToken, updateCookies } from './ApiUtil';

let SwitchEmail = () => {
    const [switchEmailState, setSwitchEmailState] = useState(false);
    const me = BootstrapData('bootstrap-data-me');
    const event = BootstrapData('bootstrap-data-event');
    const [newUser, setNewUser] = useState(false);
    const { name, websiteType, whitelabelUrl, groupId, whitelabelWidgetEnabled, onlyEventDomain} = event;
    useEffect(() => {
        // To prevent "switch email pop up", when agenda in "previewMode" in web-dashboard -> website-editor
        const url = new URL(window.location.href);
        const isWebSiteEditorModeOnDashboard = url.searchParams.get('disableInteractions');
        if (isWebSiteEditorModeOnDashboard === 'true') return;

        async function fetchData() {
            try {
                const token = Cookies.get('encodedEmailToken');
                if (token){
                    const tokenData = await verifyToken({event, token});
                    if (tokenData){
                        if (me && me.primaryEmail){
                            const user = await decodeToken(token);
                            const { primaryEmail } = user;
                            if (primaryEmail?.toLowerCase() !== me.primaryEmail?.toLowerCase()){
                                setSwitchEmailState(true);
                                setNewUser(user);
                            }
                        }
                    }
                }
            } catch (e){
                console.log(e);
            }
        }
        fetchData();
    }, []);

    const switchEmail = async() => {
        await updateCookies({ event, groupId });
        Cookies.remove('encodedEmailToken');
        window.location.reload(false);
        setSwitchEmailState(false);
    };

    const dontSwitchEmail = () => {
        Cookies.remove('encodedEmailToken');
        setSwitchEmailState(false);
    };

    return (
        <>
            <BZModal
                color='white'
                doneCta="Switch Email"
                cancelCta="Cancel"
                modalCls="switch-email-modal"
                closeCls='hidden'
                show={switchEmailState}
                onHide={() => setSwitchEmailState(false)}
                hideFooter={true}
            >
                <div className="color-1-background l switch-email-modal-close-icon" onClick={() => setSwitchEmailState(false)}>
                    <CloseIcon fill='#fff' fontSize='13'/>
                </div>
                <div className='title padding-bottom-medium'>{`Welcome back to ${name}`}</div>
                <div className='padding-bottom-medium'>
                    {'You are currently logged in under '}
                    <strong>{me.primaryEmail}</strong>.
                    {' Would you like to switch to '}
                    <strong>{newUser.primaryEmail}</strong>
                    {' email address?'}
                </div>
                <div className='button-wrapper'>
                    <button
                        className='confirm-button font-size-14 color-1-background margin-bottom-small'
                        onClick={() => switchEmail()}
                    >
                        Switch Email
                    </button>
                    <button
                        className='cancel-button font-size-14 color-1'
                        onClick={() => dontSwitchEmail()}
                    >
                        Cancel
                    </button>
                </div>
            </BZModal>
        </>
    );
};

renderReact(document.getElementsByClassName('switch-email')[0], <SwitchEmail/>);
